/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
class e{constructor(e,t){this.element=e,this.type="image+type",this.isOpaque="image/jpeg"===t}}export{e as ImageWithType};
